import type { ZodSchema } from 'zod';
import { validateSchemaAsync } from './validateSchemaAsync';

export const validateServiceResponse = <S extends ZodSchema>(schema: S) =>
  validateSchemaAsync(schema);
